import { useState, useEffect } from 'react';
import API, { fmt, PAYMENT_TYPES } from '../utils/api';
import Pagination from '../components/Pagination';

export default function Payments() {
  const [payments, setPayments] = useState([]);
  const [orders, setOrders] = useState([]);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const PER_PAGE = 50;
  const [showModal, setShowModal] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [form, setForm] = useState({
    order_id: '',
    amount: '',
    payment_type: 'cash',
    check_number: '',
    payment_date: new Date().toISOString().split('T')[0],
    notes: ''
  });

  const load = () => API.get('/payments').then(r => setPayments(r.data));

  useEffect(() => {
    load();
    API.get('/orders').then(r => {
      // فقط الطلبيات غير الملغاة وفيها مبلغ متبقي
      setOrders(r.data.filter(o => o.status !== 'cancelled' && o.remaining_amount > 0.01));
    });
  }, []);

  const filtered = payments.filter(p =>
    (p.customer_name || '').includes(search) ||
    (p.order_number || '').includes(search)
  );
  const total = filtered.reduce((s, p) => s + p.amount, 0);
  const pagedPayments = filtered.slice((page-1)*PER_PAGE, page*PER_PAGE);
  useEffect(() => { setPage(1); }, [search]);

  const selectedOrder = orders.find(o => o.id === Number(form.order_id));

  const openModal = () => {
    setForm({
      order_id: '',
      amount: '',
      payment_type: 'cash',
      check_number: '',
      payment_date: new Date().toISOString().split('T')[0],
      notes: ''
    });
    setError('');
    setShowModal(true);
  };

  const handleSubmit = async () => {
    setError('');
    if (!form.order_id) return setError('يرجى اختيار الطلبية');
    if (!form.amount || Number(form.amount) <= 0) return setError('يرجى إدخال مبلغ صحيح');
    if (selectedOrder && Number(form.amount) > selectedOrder.remaining_amount + 0.01)
      return setError(`المبلغ أكبر من المتبقي (${fmt.currency(selectedOrder.remaining_amount)})`);

    setSaving(true);
    try {
      await API.post('/payments', {
        ...form,
        order_id: Number(form.order_id),
        amount: Number(form.amount)
      });
      setShowModal(false);
      load();
      // تحديث قائمة الطلبيات بعد الدفع
      API.get('/orders').then(r => setOrders(r.data.filter(o => o.status !== 'cancelled' && o.remaining_amount > 0.01)));
    } catch (e) {
      setError(e.response?.data?.error || 'حدث خطأ');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">💰 الدفعات</h1>
        <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
          <div className="stat-card" style={{ padding: '10px 20px', margin: 0 }}>
            <span className="text-muted">إجمالي الدفعات: </span>
            <strong className="text-success">{fmt.currency(total)}</strong>
          </div>
          <button className="btn btn-primary" onClick={openModal}>+ إضافة دفعة</button>
        </div>
      </div>

      <div className="search-bar">
        <input
          className="search-input"
          placeholder="🔍 بحث بالعميل أو رقم الطلب..."
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      </div>

      <div className="table-container">
        <div className="table-scroll">
          <table>
            <thead>
              <tr>
                <th>العميل</th>
                <th>رقم الطلب</th>
                <th>المبلغ</th>
                <th>نوع الدفع</th>
                <th>رقم الشيك</th>
                <th>التاريخ</th>
                <th>المسجل بواسطة</th>
              </tr>
            </thead>
            <tbody>
              {pagedPayments.map(p => (
                <tr key={p.id}>
                  <td className="font-bold">{p.customer_name}</td>
                  <td className="text-muted">{p.order_number}</td>
                  <td className="text-success font-bold">{fmt.currency(p.amount)}</td>
                  <td><span className="badge badge-info">{PAYMENT_TYPES[p.payment_type] || p.payment_type}</span></td>
                  <td className="text-muted">{p.check_number || '-'}</td>
                  <td className="text-muted">{fmt.date(p.payment_date)}</td>
                  <td className="text-muted">{p.created_by_name}</td>
                </tr>
              ))}
              {filtered.length === 0 && (
                <tr>
                  <td colSpan={7}>
                    <div className="empty-state">
                      <div className="empty-state-icon">💰</div>
                      <p>لا توجد دفعات</p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <Pagination page={page} total={filtered.length} perPage={PER_PAGE} onPage={setPage} />
      </div>

      {/* Modal إضافة دفعة */}
      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 500 }}>
            <div className="modal-header">
              <h2 className="modal-title">💰 إضافة دفعة</h2>
              <button className="modal-close" onClick={() => setShowModal(false)}>✕</button>
            </div>
            <div className="modal-body">

              {error && (
                <div className="alert alert-danger" style={{ marginBottom: 16 }}>{error}</div>
              )}

              {/* اختيار الطلبية */}
              <div className="form-group">
                <label className="form-label">الطلبية *</label>
                <select
                  className="form-control"
                  value={form.order_id}
                  onChange={e => setForm({ ...form, order_id: e.target.value, amount: '' })}
                >
                  <option value="">— اختر الطلبية —</option>
                  {orders.map(o => (
                    <option key={o.id} value={o.id}>
                      {o.order_number} — {o.customer_name} (متبقي: {fmt.currency(o.remaining_amount)})
                    </option>
                  ))}
                </select>
              </div>

              {/* معلومات الطلبية */}
              {selectedOrder && (
                <div style={{
                  background: 'var(--bg-secondary)',
                  borderRadius: 8,
                  padding: '10px 14px',
                  marginBottom: 16,
                  fontSize: 13,
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr 1fr',
                  gap: 8
                }}>
                  <div><span className="text-muted">الإجمالي: </span><strong>{fmt.currency(selectedOrder.total)}</strong></div>
                  <div><span className="text-muted">المدفوع: </span><strong className="text-success">{fmt.currency(selectedOrder.paid_amount)}</strong></div>
                  <div><span className="text-muted">المتبقي: </span><strong className="text-danger">{fmt.currency(selectedOrder.remaining_amount)}</strong></div>
                </div>
              )}

              {/* المبلغ */}
              <div className="form-group">
                <label className="form-label">المبلغ *</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="0.00"
                  min="0.01"
                  step="0.01"
                  max={selectedOrder ? selectedOrder.remaining_amount : undefined}
                  value={form.amount}
                  onChange={e => setForm({ ...form, amount: e.target.value })}
                />
                {selectedOrder && (
                  <small className="text-muted" style={{ marginTop: 4, display: 'block' }}>
                    الحد الأقصى: {fmt.currency(selectedOrder.remaining_amount)}
                  </small>
                )}
              </div>

              {/* نوع الدفع */}
              <div className="form-group">
                <label className="form-label">نوع الدفع *</label>
                <select
                  className="form-control"
                  value={form.payment_type}
                  onChange={e => setForm({ ...form, payment_type: e.target.value })}
                >
                  {Object.entries(PAYMENT_TYPES).map(([k, v]) => (
                    <option key={k} value={k}>{v}</option>
                  ))}
                </select>
              </div>

              {/* رقم الشيك — يظهر فقط عند اختيار شيك */}
              {form.payment_type === 'check' && (
                <div className="form-group">
                  <label className="form-label">رقم الشيك</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="رقم الشيك..."
                    value={form.check_number}
                    onChange={e => setForm({ ...form, check_number: e.target.value })}
                  />
                </div>
              )}

              {/* التاريخ */}
              <div className="form-group">
                <label className="form-label">تاريخ الدفع *</label>
                <input
                  type="date"
                  className="form-control"
                  value={form.payment_date}
                  onChange={e => setForm({ ...form, payment_date: e.target.value })}
                />
              </div>

              {/* ملاحظات */}
              <div className="form-group">
                <label className="form-label">ملاحظات</label>
                <textarea
                  className="form-control"
                  rows={2}
                  placeholder="ملاحظات اختيارية..."
                  value={form.notes}
                  onChange={e => setForm({ ...form, notes: e.target.value })}
                />
              </div>

            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={() => setShowModal(false)}>إلغاء</button>
              <button className="btn btn-primary" onClick={handleSubmit} disabled={saving}>
                {saving ? '...جاري الحفظ' : '💾 حفظ الدفعة'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
